import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';

interface IAlertOptions {
  type:
    | 'error'
    | 'success'
    | 'warning'
    | 'warning-yellow'
    | 'success-green'
    | 'error-red';
  text?: string;
  hiddeCancelBtn?: boolean;
  saveButtonText: string;
  cancelButtonText: string;
  tittle?: string;
  invertOrder?: boolean;
}

@Component({
  selector: 'app-enova-alerts',
  standalone: true,
  imports: [MatButtonModule, MatDialogClose, CommonModule],
  templateUrl: './enova-alerts.component.html',
  styleUrl: './enova-alerts.component.scss',
})
export class EnovaAlertsComponent {
  constructor(
    public dialogRef: MatDialogRef<EnovaAlertsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAlertOptions
  ) {}

  getAlertImg(): string {
    switch (this.data.type) {
      case 'error':
      case 'error-red':
        return 'assets/svg/x-circle.svg';
      case 'success':
        return 'assets/svg/icon-check.svg';
      case 'warning':
      case 'warning-yellow':
        return 'assets/svg/exclamation-triangle.svg';
      case 'success-green':
        return 'assets/svg/icon-check-green.svg';
      default:
        return 'assets/svg/exclamation-triangle.svg';
    }
  }
}
